import { StyleSheet } from 'react-native';
import { Platform } from 'react-native';
import { Dimensions } from 'react-native';

let deviceWidth = Dimensions.get('window').width;

console.log(deviceWidth);

if (Platform.OS === 'ios') {
  global.platform = 'ios';
} else if (Platform.OS === 'android') {
  // other thing for android
  global.platform = 'android';
} else if (Platform.OS === 'web') {
  // it's on web!
  global.platform = 'web';
} else {
  // you probably won't end up here unless you support another platform!
  global.platform = 'web';
}

export default StyleSheet.create({
  paddingBottom15: {
    paddingBottom: 15,
  },
  paddingLeft30: {
    paddingLeft: 30,
  },
  /**accordian common styles begin*/
  paymentHeading: {
    fontSize: 28,
    color: '#273a4e',
    fontFamily: 'SFProText',
    fontWeight: '500',
    fontWeight: '600',
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'center',
    textAlign: 'center',
  },
  outerView: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  outerViewResposive_SMALL_MOBILE: {
    width: '95%',
  },
  outerViewResposive_MEDIUM_MOBILE: {
    width: '90%',
  },
  outerViewResposive_LARGE_MOBILE: {
    width: '90%',
  },
  outerViewResposive_SMALL_TABLET: {
    width: '90%',
  },
  outerViewResposive_MEDIUM_TABLET: {
    width: '80%',
  },
  outerViewResposive_LARGE_TABLET: {
    width: '70%',
  },
  outerViewResposive_LAPTOP: {
    width: '60%',
  },
  otpImageView: {
    padding: 15,
    paddingBottom: 0,
  },
  otpImage: { width: 100, height: 100 },
  paymentSubHeading: {
    alignSelf: 'center',
    // width: "80%",
    fontSize: 16,
    color: '#273a4e',
    fontFamily: 'SFProText',
    fontWeight: 'normal',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20,
    textAlign: 'center',
  },

  paymentAmounttxt: {
    alignSelf: 'center',
    width: '100%',
    fontSize: 16,
    fontWeight: 'bold',
    color: '#273a4e',
    fontFamily: Platform.OS === 'ios' ? 'SFProTextbold' : 'SFProText',
    fontWeight: 'normal',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20,
    color: '#273a4e',
    textAlign: 'center',
  },
  amountBold: { fontWeight: 'bold' },
  paymentAmount: {
    fontSize: 18,
    color: '#000000',
    //fontFamily: "GoogleSansBold",
    fontFamily: 'SFProText',
    fontWeight: '500',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20,
  },
  paymentHeadingView: {
    padding: 30,
    textAlign: 'center',
    paddingTop: 10,
  },
  mainExpandableView: {
    width: '100%',
    borderRadius: 7,
    backgroundColor: '#f1f0f0',
    borderColor: '#d4d4d4',
    marginBottom: 30,
  },
  expandableView: {
    padding: 15,
  },
  paddingDebitCard: {
    paddingTop: 0,
    paddingBottom: global.platform === 'android' ? 0 : 15,
  },
  accordianImg: {
    position: 'absolute',
    width: 39,
    height: 39,
    resizeMode: 'contain',
  },
  accordianHead: {
    justifyContent: 'space-between',
    height: 50,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  accordianText: {
    fontSize: 19,
    //fontFamily: "GoogleSansBold",
    fontFamily: 'SFProText',
    fontWeight: '500',
    marginLeft: 53,
    paddingBottom: 3,
  },
  arrowMark: {
    position: 'absolute',
    width: 24,
    height: 24,
    resizeMode: 'contain',
  },
  iconText: {
    width: '80%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  toggleIconWidth: {
    width: '20%',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
  },
  accordianWithBorder: {
    borderBottomWidth: 1,
    borderBottomColor: '#e5e5e5',
  },
  accordianWithNoBorder: {
    borderBottomWidth: 0,
  },

  /**accordian common styles end*/

  /**paymentpage inputs styles begin */
  paymentTextInputChildView: {
    width:
      global.platform !== 'web' ? '100%' : deviceWidth < 700 ? '100%' : '47%',
    marginBottom: deviceWidth <= 768 ? 5 : 10,
    marginTop: deviceWidth <= 768 ? 5 : 10,
  },
  paymentTextInput: {
    height: 48,
    borderRadius: 7,
    backgroundColor: 'white',

    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 10,
    paddingBottom: 7,
    fontSize: 16,
    fontFamily: 'SFProText',
    color: 'black',
  },
  paymentTextInputView: {
    paddingLeft: 0,
    // paddingTop: 15,
    // paddingBottom: 15,
    display: 'flex',
    flexDirection:
      global.platform !== 'web'
        ? 'column'
        : deviceWidth < 700
        ? 'column'
        : 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    maxWidth: 630,
  },
  payBtnView: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  errorMsgtxt: {
    padding: 5,
    color: 'red',
    fontFamily: 'SFProText',
    fontSize: 16,
  },
  paymentInputRadioButtonViewBox: {
    padding: deviceWidth <= 768 ? 10 : 20,
  },
  internetBanking: { width: '100%' },

  /**paymentpage inputs styles end */

  /**payment success screen begin */
  successContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    // marginTop: '5%',
    // marginLeft:
    //   global.platform !== 'web' ? '5%' : deviceWidth < 800 ? '5%' : '20%',
    // marginRight:
    //   global.platform !== 'web' ? '5%' : deviceWidth < 800 ? '5%' : '20%',
  },

  successLogo: {
    marginTop: 100,
    width: 78,
    height: 78,
  },
  paymentSuccessHead: {
    textAlign: 'center',
    fontSize: 28,
    fontFamily: 'SFProText',
    fontWeight: '500',
    paddingTop: 20,
    paddingBottom: 20,
    color: '#273a4e',
  },
  paymentSuccessSubText: {
    fontSize: 16,
    fontWeight: 'normal',
    padding: 15,
    color: '#273a4e',
    textAlign: 'center',
    width: '80%',
    fontFamily: 'SFProText',
  },
  closeBtn: {
    backgroundColor: '#3fb7f5',
    borderRadius: 2,
    padding: 5,
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeWBtnText: {
    color: 'white',
    fontSize: 16,
    fontFamily: 'SFProText',
    textAlign: 'center',
  },
  payNoWBtns: {
    backgroundColor: '#3fb7f5',
    borderRadius: 7,
    borderWidth: 0,
    width: deviceWidth < 340 ? 245 : 270,
    height: 40,
    padding: 4,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: deviceWidth < 768 ? 10 : 0,
  },
  payNoWBtnText: {
    color: 'white',
    fontSize: 16,
    fontFamily: 'SFProText',
    fontWeight: '500',
    textAlign: 'center',
  },
  /**payment success screen end */
  /**otp screen  begin*/
  resendBtn: {
    // marginLeft: '25%',
    // marginRight: 100,
    // justifyContent: 'flex-end',
    flexDirection: 'row',
    color: '#3fb7f5',
    fontSize: 18,
    // fontFamily: 'Calibri',
    // cursor: 'pointer',
  },
  resendBtn_SMALL_MOBILE: {
    marginRight: 5,
  },
  resendBtn_MEDIUM_MOBILE: {
    marginRight: 10,
  },
  resendBtn_LARGE_MOBILE: {
    marginRight: 20,
  },
  resendBtn_SMALL_TABLET: {
    marginRight: 100,
  },
  resendBtn_MEDIUM_TABLET: {
    marginLeft: '25%',
    marginRight: 65,
  },
  resendBtn_LARGE_TABLET: {
    marginLeft: '25%',
    marginRight: 100,
  },
  resendBtn_LAPTOP: {
    marginLeft: '25%',
    marginRight: 80,
  },
  redendOtpText: {
    color: '#ed705b',
    fontSize: 16,
    fontFamily: 'SFProText',
  },
  otpErrorMsg: {
    color: 'red',
  },
  otpErrorMsg_SMALL_MOBILE: {
    marginLeft: '2%',
  },
  otpErrorMsg_MEDIUM_MOBILE: {
    marginLeft: '2%',
  },
  otpErrorMsg_LARGE_MOBILE: {
    marginLeft: '12%',
  },
  otpErrorMsg_SMALL_TABLET: {
    marginLeft: '15%',
  },
  otpErrorMsg_MEDIUM_TABLET: {
    marginLeft: '5%',
  },
  otpErrorMsg_LARGE_TABLET: {
    marginLeft: '9%',
  },
  otpErrorMsg_LAPTOP: {
    marginLeft: '11%',
  },

  viewOtpError: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  viewOtpError_SMALL_MOBILE: {
    width: '75%',
  },
  viewOtpError_MEDIUM_MOBILE: {
    width: '72%',
  },
  viewOtpError_LARGE_MOBILE: {
    width: '75%',
  },
  viewOtpError_SMALL_TABLET: {
    width: '62%',
  },
  viewOtpError_MEDIUM_TABLET: {
    width: '50%',
  },
  viewOtpError_LARGE_TABLET: {
    width: '40%',
  },
  viewOtpError_LAPTOP: {
    width: '47%',
  },
  timerText: {
    color: '#ed705b',
    fontSize: 14,
    fontFamily: 'SFProText',
    // marginLeft:100,
  },

  otpView: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  safeAreaViewStyle: {
    flex: 1,
  },

  safeAreaViewChild: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
});
